

import React from 'react';
import { CustomerLayout } from '../../components/ui/Layout';
import { useStore } from '../../context/StoreContext';
import { Clock, ShoppingBag, ChevronRight, Calendar, MapPin, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const OrderHistoryPage: React.FC = () => {
  const { orders, restaurant } = useStore();
  // Mock filter for current user (In real app, filter by auth user ID)
  const myOrders = orders; // Showing all for demo

  if(!restaurant) return null;

  return (
    <CustomerLayout showCart={false}>
      <div className="px-4 md:px-0 pb-20 max-w-2xl mx-auto">
        <header className="mb-8 pt-4">
             <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <ShoppingBag className="w-6 h-6 text-primary-600" /> Meus Pedidos
             </h1>
             <p className="text-gray-500 text-sm mt-1">Acompanhe seus pedidos anteriores</p>
        </header>

        {myOrders.length === 0 ? (
             <div className="text-center py-20 bg-white rounded-2xl shadow-sm border border-gray-100">
                <div className="inline-block p-4 bg-gray-50 rounded-full mb-4">
                    <ShoppingBag className="w-8 h-8 text-gray-400" />
                </div>
                <h3 className="font-bold text-gray-800 text-lg">Nenhum pedido ainda</h3>
                <p className="text-gray-500 text-sm mb-6">Você ainda não fez nenhum pedido conosco.</p>
                <Link to="/menu" className="inline-block bg-primary-600 text-white px-6 py-2.5 rounded-xl font-bold hover:bg-primary-700 transition-colors">
                    Fazer Pedido
                </Link>
             </div>
        ) : (
            <div className="space-y-4">
                {myOrders.map(order => (
                    <Link 
                        to={`/track/${order.id}`} 
                        key={order.id}
                        className="block bg-white rounded-2xl p-5 shadow-card hover:shadow-float transition-all border border-transparent hover:border-primary-100 group"
                    >
                        <div className="flex justify-between items-start mb-4">
                            <div className="flex items-center gap-3">
                                <div className="bg-gray-100 p-2.5 rounded-xl text-gray-600">
                                    <ShoppingBag className="w-5 h-5" />
                                </div>
                                <div>
                                    {/* FIX: Property 'name' does not exist on type 'InstagramProfile'. Use 'username' instead. */}
                                    <h3 className="font-bold text-gray-900">{restaurant.username}</h3>
                                    <span className="text-xs text-gray-500 font-medium flex items-center gap-1">
                                        <Calendar className="w-3 h-3" />
                                        {new Date(order.createdAt).toLocaleDateString('pt-BR')} às {new Date(order.createdAt).toLocaleTimeString('pt-BR', {hour: '2-digit', minute:'2-digit'})}
                                    </span>
                                </div>
                            </div>
                            <span className={`text-xs px-2.5 py-1 rounded-full font-bold uppercase tracking-wider ${
                                order.status === 'COMPLETED' ? 'bg-green-100 text-green-700' : 
                                order.status === 'CANCELLED' ? 'bg-red-100 text-red-700' : 'bg-blue-50 text-blue-700'
                            }`}>
                                {order.status === 'PENDING' ? 'Enviado' : 
                                 order.status === 'CONFIRMED' ? 'Confirmado' :
                                 order.status === 'PREPARING' ? 'Preparando' :
                                 order.status === 'READY' ? 'Saiu p/ Entrega' :
                                 order.status === 'COMPLETED' ? 'Entregue' : 'Cancelado'}
                            </span>
                        </div>

                        <div className="border-t border-b border-gray-50 py-3 mb-3 space-y-1">
                            {order.items.map((item, idx) => (
                                <div key={idx} className="flex justify-between text-sm text-gray-600">
                                    <span>{item.quantity}x {item.productName}</span>
                                </div>
                            ))}
                            {order.items.length > 2 && <span className="text-xs text-gray-400 italic">+ outros itens...</span>}
                        </div>

                        <div className="flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-400 font-medium">Total</span>
                                <span className="font-bold text-gray-900">{restaurant.currency} {order.total.toFixed(2).replace('.', ',')}</span>
                            </div>
                            <div className="flex items-center gap-1 text-primary-600 font-bold text-sm group-hover:translate-x-1 transition-transform">
                                Ver Detalhes <ChevronRight className="w-4 h-4" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        )}
      </div>
    </CustomerLayout>
  );
};

export default OrderHistoryPage;